import React, { useState, useEffect } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Rank',
    key: 'rank',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-GamesTableColumn-rank',
  },
  {
    name: 'Title',
    key: 'title',
    size: 'medium',
    sortable: true,
    dataCyClassName: 'Usage-GamesTableColumn-title',
  },
  {
    name: 'Passengers',
    key: 'passengers',
    size: 'xsmall',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengers',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-LiveTVTableColumn-passengerPoolPer',
  },
  {
    name: 'Avg view mins',
    key: 'avg_views_min',
    size: 'small',
    sortable: true,
    dataCyClassName: 'Usage-GamesTableColumn-avgViewsMin',
  },
];

const data = [
  {
    rank: '1',
    title: 'Trivia Tournament',
    passengers: {
      display: '18,810',
      sort: 18810,
    },
    passenger_pool_per: '4.3%',
    avg_views_min: 34,
  },
  {
    rank: '2',
    title: 'Mickey Mouse Date Dash',
    passengers: {
      display: '18,030',
      sort: 18030,
    },
    passenger_pool_per: '4.1%',
    avg_views_min: 30,
  },
  {
    rank: '3',
    title: 'Sky Wellness',
    passengers: {
      display: '15,390',
      sort: 15390,
    },
    passenger_pool_per: '3.5%',
    avg_views_min: 38,
  },
  {
    rank: '4',
    title: 'Puzzle Travel Showcase',
    passengers: {
      display: '14,250',
      sort: 14250,
    },
    passenger_pool_per: '3.2%',
    avg_views_min: 38,
  },
  {
    rank: '5',
    title: 'Little Twin Stars',
    passengers: {
      display: '14,100',
      sort: 14100,
    },
    passenger_pool_per: '3.2%',
    avg_views_min: 40,
  },
];

const Games = () => {
  const [filterData, setFilterData] = useState(data);
  const [filters, setFilters] = useState(defaultUsageFilters);

  useEffect(() => {
    const { searchText } = filters;
    const filteredData = data.filter((obj) => {
      return obj.title.toLowerCase().startsWith(searchText?.toLowerCase());
    });
    setFilterData(filteredData);
  }, [filters]);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-Games-Header" className="title_1">
            Games
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={filterData}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default Games;
